export default function AtcFlightSegmentAlternativesService(
    atcFlightRecommendationService,
    atcFlightSegmentService,
    atcFlightGroupService
) {
    'ngInject';

    Object.assign(this, {
        doesOverlapSiblingSegments,
        doesOverlapPreviousSegment,
    });

    function doesOverlapSiblingSegments(recommendation, segment, group, selectedFlights) {
        return doesOverlapPreviousSegment(recommendation, segment, group, selectedFlights)
            || doesOverlapNextSegment(recommendation, segment, group, selectedFlights);
    }

    function doesOverlapPreviousSegment(recommendation, segment, group, selectedFlights) {
        if (atcFlightRecommendationService.isOneWayTrip(recommendation)) {
            return false;
        }

        const previousSegment = atcFlightSegmentService.getPreviousSegment(recommendation, segment);
        if (!previousSegment) {
            return false;
        }

        const returnFlight = atcFlightGroupService.getFirstFlight(group);
        const departureDate = returnFlight.DepartureDate;

        const previousGroup = atcFlightSegmentService.getSelectedGroup(selectedFlights, previousSegment);
        const previousFlight = atcFlightGroupService.getLastFlight(previousGroup);
        const arrivalDate = previousFlight.ArrivalDate;

        return new Date(arrivalDate) > new Date(departureDate);
    }

    function doesOverlapNextSegment(recommendation, segment, group, selectedFlights) {
        if (atcFlightRecommendationService.isOneWayTrip(recommendation)) {
            return false;
        }

        const nextSegment = atcFlightSegmentService.getNextSegment(recommendation, segment);
        if (!nextSegment) {
            return false;
        }

        const outwardFlight = atcFlightGroupService.getLastFlight(group);
        const arrivalDate = outwardFlight.ArrivalDate;

        const nextGroup = atcFlightSegmentService.getSelectedGroup(selectedFlights, nextSegment);
        const nextFlight = atcFlightGroupService.getFirstFlight(nextGroup);
        const departureDate = nextFlight.DepartureDate;

        return new Date(arrivalDate) > new Date(departureDate);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/flight-recommendation/flight-segment/flight-segment-alternatives/flight-segment-alternatives-service.js